import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import { LocalizationContext } from '../../App';
import uuid from 'react-uuid';


const LoupeLikerMultipletItemSelectionComponent = props => {

    const isMobileView = useMediaQuery({        
        query: '(max-width: 900px)'
    });
    const isWideView = useMediaQuery({
        query: '(min-width: 1200px)'
    });
    const isNarrowDesktop = useMediaQuery({
        query: '(min-width: 900px)'
    });
    

    const currentItem = props.currentItem;    
    const [value, setValue] = React.useState(currentItem.scales);

    const itemRevalidation = () => {

        var hadError = false;
        currentItem.scales.map(sel => {
            if(sel.selectedValue == "") {
                hadError = true;
            }
        });

        if(hadError){
            currentItem.validator.untouch();
        } else {
            currentItem.validator.touched();
        }
    }
    
    itemRevalidation();


    const myChange = (event, idx, obj) => {       
        obj.setValue(event.target.value);
        itemRevalidation();

        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }

        setValue(
            value.map((g, iix) =>                 
                iix === idx ? { ...g, selectedValue: event.target.value } : { ...g }
            )                
        );  
    };

    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 

        <div>
            <LoupeItemHeaderComponent currentItem={currentItem} />  

            { isMobileView == false ? 
            (
                <>                    

                    <Grid container spacing={2} justifyContent="center">

                        <Grid item xs={12}>
                            {/* <FormControl component="fieldset"> */}

                                <Grid container spacing={2} justifyContent="center">

                                    { value.map( (s, idx, arr) => {
                                    
                                        var isLastItem = (idx == arr.length - 1) ? true : false;
                                        var printInvisibleLabels = ( !isLastItem && (currentItem.includeNa == true || currentItem.units == 0)) ? true : false;

                                        return ( 

                                            <React.Fragment key={s.id + "_wrap"}>
                                            
                                                <Grid item xs={ isWideView == true ? 4 : 12 }>
                                                    {s.label}
                                                </Grid>

                                                <Grid item xs={ isWideView == true ? 7 : 12 }>
                                                                                                       
                                                    <Grid container item xs={12} justifyContent="space-evenly">
                                                        <RadioGroup                                                                                                                   
                                                            key={s.id + "_group"}
                                                            value={value[idx].selectedValue}
                                                            onChange={(event) => myChange(event, idx, s)}
                                                            row={true}>
                                                            
                                                            { s.unitItems.map( (u, idx, arr) => {
                                                                return(<Grid item xs key={uuid()}>                                                                    
                                                                    <FormControlLabel {...(isLastItem == true ? {} : { style : { color : 'transparent' }  })} labelPlacement={'bottom'} label={ (printInvisibleLabels == true || isLastItem == true ) ? u.label : '' } value={u.value} key={u.id} control={<Radio />}/>
                                                                </Grid>
                                                                );
                                                            })}

                                                            { currentItem.includeNa == "true" && 
                                                            <Grid item xs>
                                                                <FormControlLabel {...(isLastItem == true ? {} : { style : { color : 'transparent' }  })} labelPlacement={ isMobileView == true ? 'end' : 'bottom' } label={ (currentItem.definedNa == "") ? strings.getString("texts.items.na") : currentItem.definedNa } value={"not-applicable"} key={"not-applicable"} control={<Radio />}/>
                                                            </Grid>
                                                            }
                                                        
                                                        </RadioGroup>
                                                    </Grid>
                                                   
                                                
                                                    { (isLastItem && currentItem.minLabel != "") &&                                                
                                                        <React.Fragment key={s.id + "_labelWrapper"}>
                                                            <p className="mb-4"/>
                                                            <div key={s.id + "_label"} style={{ alignContent : 'center' }}>{currentItem.minLabel} &mdash; {currentItem.maxLabel}</div>                                                                                                                   
                                                        </React.Fragment>
                                                    }
                                                   
                                                    

                                                </Grid>

                                                <Grid item xs />
                                                

                                            </React.Fragment>
                                        );
                                    
                                    
                                    })}

                                  
                                </Grid>                        
                            {/* </FormControl>                    */}

                        </Grid>

                    </Grid>     
               
                </>
            )
             : (
                <>
                <Grid container spacing={2}>
                    <Grid item xs/>
                        <Grid item xs={12}>     
                            <FormControl component="fieldset">

                                { value.map( (s, idx, arr) => {

                                    return (

                                        <Grid item xs={12} key={s.id + "_wrap"}>
                                            
                                                <p className="mb-4" />
                                                <FormLabel>{s.label}</FormLabel>                                                          
                      
                                                    <RadioGroup
                                                        style={{ alignContent : 'center'}}
                                                        key={s.id + "_group"}
                                                        value={value[idx].selectedValue}
                                                        onChange={(event) => myChange(event, idx, s)}
                                                        row={false}>
                                                        
                                                        { s.unitItems.map( (u, idx, arr) => {

                                                            var radioLabel = u.label;                                                                                                              
                                                            // check for first element
                                                            if( idx == 0 ) {
                                                                radioLabel = <><span>{u.label}</span><span style={{marginLeft : '20px'}}>{currentItem.minLabel}</span></>;
                                                            }

                                                            // check for last element
                                                            if( idx == (arr.length - 1)) {
                                                                radioLabel = <><span>{u.label}</span><span style={{marginLeft : '20px'}}>{currentItem.maxLabel}</span></>;
                                                            }

                                                            return(
                                                                <FormControlLabel labelPlacement={'end'} label={radioLabel} value={u.value} key={u.id} control={<Radio />}/>
                                                            );
                                                        })}

                                                    </RadioGroup>
                                                   
                                            
                                        </Grid>                                        

                                    );

                                }) }
                            </FormControl>
                        </Grid>
                    <Grid item xs/>
                </Grid>
                    

                   
                   
                </>
            )}                   

        </div>
        }
    </LocalizationContext.Consumer>
      );



}
export default LoupeLikerMultipletItemSelectionComponent;